import React, { useState, useEffect, useContext, useRef, createRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import AddCombo from './images/icons/AddCombo.png'
import Minus1 from './images/icons/minu1.png'
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import './css/AddonReg.css'
import Select, { components } from 'react-select';
import { DBContext } from './DBContext'
import axios from 'axios'
import searchingLotties from './images/lotties/searchingLottie.json'
import Lottie from "lottie-react";
import domain from './images/icons/domain.png'
import UploadImg from './images/MenuReg/uploadItem.png'
import cross from './images/icons/cross.png'
import SideNavMob from './SideNavMob'
import RightNavMob from './RightNavMob'
import NavBarMobile from './Mobile/NavBar'

function AddonReg() {


    const api_base_url = process.env.REACT_APP_API_BASE_URL

    const { customerCode, logginedDB, sideNavState, sideNavStateFunc, rightNavState, rightNavStateFunc } = useContext(DBContext);

    const navigate = useNavigate();
    const location = useLocation();

    const [editItem, setEdititem] = useState(false)
    const [editItemCode, setEditItemCode] = useState(null);
    const [editItems, setEditItems] = useState(null);
    useEffect(() => {
        // Process location.state only on initial mount
        // if (location.state === 'toEdit') {
        if (location.state) {

            setEdititem(true)
            setEditItemCode(location.state.id);
            setEditItems(location.state.area);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);


    const handleCancel = () => {
        navigate('/basemenureg', {
            state: 'addonCancel'
        })
    }

    const handleSaveAddon = async () => {
        if (!selectedOption) {
            return alert("Select product!");
        }

        const formData = new FormData();
        console.log(addonCombos);

        formData.append('addonCombos', JSON.stringify(addonCombos));
        addonCombos.forEach((addon) => {
            formData.append('addonCombos', addon.itemImage); // Files
        });
        console.log(selectedOption.value, customerCode, logginedDB, itemCode[0].itemCode);
        console.log("formData", typeof formData)
        try {
            const response = await axios.post(
                `${api_base_url}/postAddons/${selectedOption.value}/${customerCode}/${logginedDB}/${itemCode[0].itemCode}`,
                formData
            );
            console.log("response", response)
            if (response.status === 200) {
                navigate('/basemenureg', { state: 'addonCancel' });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };


    const [selectedOption, setSelectedOption] = useState(null)

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            fontSize: '.9em',
            // fontFamily: 'Poppins',
            textAlign: 'left',
            backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF',
            color: state.isFocused ? '#000' : '#000',
            cursor: 'pointer', // Add cursor pointer on hover
            ':hover': {
                backgroundColor: '#c8cbcf',
                color: '#000',
            },
            ':active': {
                ...provided[':active'],
                backgroundColor: '#c8cbcf'
            }
        }),
        control: (provided, state) => ({
            ...provided,
            width: '100%',
            // height: '2.5rem',
            minHeight: '2.5rem',
            fontSize: '1em',
            borderRadius: '.313rem', // Adjust this value as needed
            padding: '0', // Ensure no extra padding is added
            // border: 'none',
            // fontWeight: '500',
            // color: 'white !important', // Set text color to white
            backgroundColor: 'transparent', // Change this to 'transparent' for a clear background
            boxShadow: 'none', // Remove the blue focus shadow
            border: '1px solid #ccc',
            '&:hover': {
                borderBottom: '1px solid #c8cbcf', // Optional: border on hover
            }
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '2.25rem',
            minHeight: '2rem',
            padding: '0 8px', // Center the text vertically
            display: 'flex',
            //   color: '#fff',
            alignItems: 'center',
            fontSize: '.9rem'
        }),
        input: (provided) => ({
            ...provided,
            height: '2.25rem',
            minHeight: '2rem',
            margin: '0',
            padding: '0',
            //   color: '#fff',
            fontSize: '.9rem'
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '2.25rem',
            display: 'flex',
            alignItems: 'center',
            padding: '.5rem',
            paddingTop: '0',
            paddingBottom: '0'
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0', // Remove padding to center the icon
            width: '1rem',
            marginLeft: '.5rem',
            //   color: '#fff',
            cursor: 'pointer',
        }),
        placeholder: (provided) => ({
            ...provided,
            //   margin: '0',
            //   fontSize: '1em',
            //   color: '#fff',
            //   fontFamily: 'poppins'
        }),
        menu: (provided) => ({
            ...provided,
            //   borderRadius: '.1rem', // Adjust this value as needed
        }),
        singleValue: (provided) => ({
            ...provided,
            // color: 'white', // Set selected option text color to white
        }),
    };

    const handleChange = (option) => {
        setSelectedOption(option)
    }

    const [options, setOptions] = useState([])

    const handleGetProduct = async () => {
        try {
            const response = await axios.get(`${api_base_url}/getItem/${logginedDB}/${customerCode}`)
            if (response.status == 200) {
                const transformedData = response.data.data.map(item => ({
                    value: item.id_productReg,
                    label: item.productName,
                }));
                setOptions(transformedData)
            }
        } catch (error) {
            //(error);
        }
    }

    const [itemCode, setItemCode] = useState(true)

    const handleGetItemCode = async (id) => {
        try {
            const response = await axios.get(`${api_base_url}/getItemCode/${id}/${logginedDB}`)
            if (response.status == 200) {
                setItemCode(response.data.data)
            }
        } catch (error) {
            //(error);
        }
    }

    useEffect(() => {
        handleGetProduct()
    }, [api_base_url, logginedDB])

    useEffect(() => {
        if (selectedOption) {
            handleGetItemCode(selectedOption.value)
        }
    }, [selectedOption])

    const [addonCombos, setAddonCombos] = useState([{ itemName: '', itemPrice: '', itemImage: '', isAdding: true }])

    const handleOnChangeValue = (e, index, item) => {
        const value = e.target.value;

        // Create a copy of the variants array
        const updatedAddons = [...addonCombos];

        // Update the respective item (itemName or itemPrice) at the given index
        updatedAddons[index] = {
            ...updatedAddons[index],
            [item]: value,
        };

        // Update the state with the modified variants array
        setAddonCombos(updatedAddons);
    };


    const [addonErrors, setAddonErrors] = useState({});
    // Function to handle adding variants
    const handleAddOrDeleteVariants = (index) => {
        // Retrieve the current addon combo
        const currentAddon = addonCombos[index];

        // Initialize errors for the current index
        const errors = { ...addonErrors };

        // Check if both itemName and itemPrice are provided
        if (currentAddon.itemName) {
            if (currentAddon.isAdding) {
                const newAddon = { itemName: '', itemPrice: '', isAdding: false };
                const updatedAddons = [...addonCombos];

                // Preserve the value of the current input fields and mark it as not adding
                updatedAddons[index] = {
                    ...updatedAddons[index],
                    isAdding: false,
                };

                updatedAddons.push({ itemName: '', itemPrice: '', isAdding: true });
                setAddonCombos(updatedAddons);
            } else {
                // Remove the item at the given index
                const updatedAddons = addonCombos.filter((addon, idx) => idx !== index);
                setAddonCombos(updatedAddons);

                const entries = Object.entries(preview);

                // Remove the entry with the specified index
                const updatedEntries = entries.filter(([key]) => Number(key) !== index);

                // Reassign indices in the updated object
                const updatedPreview = updatedEntries.reduce((acc, [_, value], idx) => {
                    acc[idx] = value; // Assign new sequential indices
                    return acc;
                }, {});

                // Update the state
                setPreview(updatedPreview);

            }

            // Clear errors for the current index
            delete errors[index];
            setAddonErrors(errors);
        } else {
            // Set specific errors for itemName and itemPrice
            errors[index] = {
                itemName: !currentAddon.itemName,
                // itemPrice: !currentAddon.itemPrice,
            };
            setAddonErrors(errors);
        }
    };

    const handleOnBlurItemName = (index) => {
        // Get the itemName value for the specific index
        const itemName = addonCombos[index].itemName;
        const state = addonCombos[index].isAdding;

        // Check if itemName is empty
        if (itemName.length <= 0 && !state) {
            // Remove the item if itemName is empty
            const updatedAddons = addonCombos.filter((variant, idx) => idx !== index);
            setAddonCombos(updatedAddons);
        }
    };

    const [sideNav, setSideNav] = useState(false)
    const handleSideNav = (state) => {
        setSideNav(state)
    }
    const [falseState, setFalseState] = useState(null)

    const fileInputRef = useRef([]);

    // Ensure `fileInputRef` has enough refs for all addons
    if (fileInputRef.current.length !== addonCombos.length) {
        fileInputRef.current = Array(addonCombos.length)
            .fill()
            .map((_, i) => fileInputRef.current[i] || createRef());
    }

    // const [image, setImage] = useState(null);
    const [preview, setPreview] = useState({});

    // //(preview);

    const [loading, setLoading] = useState(false);

    const handleDivClick = (index) => {
        // Click the hidden file input element
        return fileInputRef.current[index].current.click();
    };

    const handleImageChange = (event, index, item) => {
        const file = event.target.files[0];
        //(file);

        if (file) {
            setLoading(true); // Set loading to true when starting to load
            // setImage(file);

            // Create a copy of the variants array
            const updatedAddons = [...addonCombos];

            // Update the respective item (itemName or itemPrice) at the given index
            updatedAddons[index] = {
                ...updatedAddons[index],
                [item]: file,
            };

            // Update the state with the modified variants array
            setAddonCombos(updatedAddons);

            // Preview the image immediately
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(prev => ({
                    ...prev,
                    [index]: reader.result
                }));
            };
            reader.readAsDataURL(file);
            setLoading(false);
        }
    };

    const [searchingWeb, setSearchingWeb] = useState({})

    // //(searchingWeb);


    const handleGenerateWebImg = async (e, index, itemName, fieldName) => {
        e.stopPropagation()

        if (!itemName) return alert("Item Name required!");
        // setSearchingWeb(true);
        setSearchingWeb(prev => ({
            ...prev,
            [index]: 1
        }));
        setPreview(prev => ({
            ...prev,
            [index]: null
        }));

        try {
            const response = await axios.get(`${api_base_url}/GetWebGeneratedImage/${itemName}`);
            if (response.status === 200) {
                setSearchingWeb(prev => ({
                    ...prev,
                    [index]: 0
                }));

                const base64Image = response.data.base64Image;
                const byteArray = response.data.data;

                if (base64Image) {
                    // If base64Image exists, use it to create the Blob
                    const base64 = base64Image.split(',')[1]; // Remove "data:image/x-icon;base64," prefix
                    const binaryData = atob(base64);
                    const buffer = new Uint8Array(binaryData.length);

                    for (let i = 0; i < binaryData.length; i++) {
                        buffer[i] = binaryData.charCodeAt(i);
                    }

                    const blob = new Blob([buffer], { type: 'image/x-icon' }); // MIME type matches the prefix in base64Image

                    if (blob.size > 0) {
                        const file = new File([blob], `${itemName}.ico`, { type: 'image/x-icon' });
                        // setPreview(URL.createObjectURL(file));
                        // setImage(file);

                        setPreview(prev => ({
                            ...prev,
                            [index]: URL.createObjectURL(file)
                        }));

                        // Create a copy of the variants array
                        const updatedAddons = [...addonCombos];

                        // Update the respective item (itemName or itemPrice) at the given index
                        updatedAddons[index] = {
                            ...updatedAddons[index],
                            [fieldName]: file,
                        };

                        // Update the state with the modified variants array
                        setAddonCombos(updatedAddons);

                    } else {
                        console.error("Blob size is zero, invalid image data.");
                    }
                } else if (byteArray) {
                    // If byteArray exists, use it to create the Blob
                    const blob = new Blob([new Uint8Array(byteArray)], { type: 'image/x-icon' });

                    if (blob.size > 0) {
                        const file = new File([blob], `${itemName}.ico`, { type: 'image/x-icon' });
                        // setPreview(response.data.base64Image);
                        // setImage(file);

                        setPreview(prev => ({
                            ...prev,
                            [index]: response.data.base64Image
                        }));

                        // Create a copy of the variants array
                        const updatedAddons = [...addonCombos];

                        // Update the respective item (itemName or itemPrice) at the given index
                        updatedAddons[index] = {
                            ...updatedAddons[index],
                            [fieldName]: file,
                        };

                        // Update the state with the modified variants array
                        setAddonCombos(updatedAddons);

                    } else {
                        console.error("Blob size is zero, invalid image data.");
                    }
                } else {
                    console.error("No valid image data found in the response.");
                }
            }
        } catch (error) {
            console.error("Error generating web image:", error);
        }
    };


    return (
        <div className='w-screen h-screen flex overflow-hidden'>
            <div className='w-full h-full overflow-hidden hidden sm:flex sm:flex-col'>
                <SherDineNav sideNav={(state) => handleSideNav(state)} falseState={falseState} />
                <div className='TableRegContentDiv flex gap-3'>
                    <SideNav focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)} />
                    <div className='TableRegContentSideBarRight'>
                        <div className="RegSidebar">
                            <TopRootDiv image={'Menu Management'} root={['Menu Management']} section={'Base menu'} />
                        </div>
                        <div className='Container_Menu Container_Menu_BaseMenuReg flex flex-col h-full pt-3'>
                            <div className='MenuReg_Category_category bg-white flex flex-col flex-grow h-full rounded-md shadow-sm border border-gray-200'>
                                <div className='MenuReg_AddosCombo border-b px-4 py-3'>
                                    <span className='MenuReg_AddosCombo_TitleSapn'>Addon Registration</span>
                                    <div className='MenuReg_AddosCombo_TitleButtonsDiv'>
                                        <button className='loginBorder text-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={handleCancel}>Cancel</button>
                                        <button className='loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={handleSaveAddon}>Save</button>
                                    </div>
                                </div>
                                <div className='w-full flex gap-3 p-4'>
                                    <div className='w-1/2 flex flex-col gap-1'>
                                        <span>Item Name</span>
                                        {/* <input type="text" placeholder=''/> */}
                                        <div className='w-full'>
                                            <Select
                                                styles={customStyles}
                                                placeholder='Select...'
                                                value={selectedOption}
                                                options={options}
                                                onChange={(selectedOption) => handleChange(selectedOption)}
                                            // components={{ 
                                            // 	Option: CustomOption,
                                            // 	SingleValue: CustomSingleValue, 
                                            // 	Placeholder: CustomPlaceholder
                                            // }}
                                            // isDisabled={true}
                                            />
                                        </div>
                                    </div>
                                    <div className='w-1/2 flex flex-col gap-1'>
                                        <span>Item Code</span>
                                        <input className={`h-[2.5rem] p-2 ${itemCode ? 'bg-slate-100' : ''}`}
                                            type="text"
                                            placeholder={editItem && editItemCode}
                                            disabled={itemCode}

                                            value={itemCode[0] && itemCode[0].itemCode} />
                                    </div>
                                </div>

                                {
                                    selectedOption && (
                                        <div className='flex flex-col w-full h-full font-nunito px-4 pb-4 overflow-y-auto flex-grow'>
                                            <div className='w-full h-max flex rounded-t-[.313rem] text-center bg-[#dbdbdb] text-[1rem] font-[600]'>
                                                <div className='w-4/12 text-left p-3'>Item Name</div>
                                                <div className='w-4/12 p-3'>Price</div>
                                                <div className='w-2/12 p-3'></div>
                                                <div className='w-2/12 p-3'>Action</div>
                                            </div>
                                            <div className='w-full h-full flex flex-col'>
                                                {addonCombos.map((addon, index) => (
                                                    <div key={index} className='flex w-full h-[4rem]'>
                                                        <div className='w-4/12 p-3 flex justify-center items-center relative'>
                                                            <input className={`w-full borderBottem pr-3 ${addonErrors[index]?.itemName ? 'AddonFieldError' : ''}`} type="text"
                                                                value={addon.itemName}
                                                                onBlur={() => handleOnBlurItemName(index)}
                                                                onChange={(e) => handleOnChangeValue(e, index, 'itemName')} />
                                                            {addon.itemName && (
                                                                <img className='absolute right-3 w-[1rem] cursor-pointer' src={domain} alt="" onClick={(e) => handleGenerateWebImg(e, index, addon.itemName, 'itemImage')} />
                                                            )}
                                                        </div>
                                                        <div className='w-4/12 p-3 flex justify-center items-center'>
                                                            <input className={`w-full borderBottem ${addonErrors[index]?.itemPrice ? 'AddonFieldError' : ''}`} type="number"
                                                                value={addon.itemPrice}
                                                                onBlur={() => handleOnBlurItemName(index)}
                                                                onChange={(e) => handleOnChangeValue(e, index, 'itemPrice')} />
                                                        </div>
                                                        <div className='w-2/12 p-1 flex justify-center items-center'>
                                                            <div className='w-max h-[2.5rem] flex justify-center px-[1.75rem] items-center cursor-pointer rounded-[.313rem]' onClick={() => handleDivClick(index)}>
                                                                <input
                                                                    type="file"
                                                                    ref={fileInputRef.current[index]}
                                                                    style={{ display: 'none' }}
                                                                    onChange={(e) => handleImageChange(e, index, 'itemImage')}
                                                                />
                                                                {(loading || searchingWeb[index]) ? (
                                                                    loading ? <div className='loading-indicator'>Uploading...</div> :
                                                                        searchingWeb[index] === 1 ? <Lottie animationData={searchingLotties} loop={true} /> : null
                                                                ) : preview[index] ? (
                                                                    <div className='w-full h-full relative'>
                                                                        <img className='w-full h-full rounded-[.313rem]' src={preview[index]} alt="Uploaded" />
                                                                    </div>
                                                                ) : (
                                                                    <div className='flex flex-col justify-center items-center gap-2 text-[.75rem]'>
                                                                        <img className={`w-[2rem]`} src={UploadImg} alt="Upload Image" />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className='w-2/12 p-3 flex justify-center items-center'>
                                                            <img className='w-[1.25rem] cursor-pointer' src={addon.isAdding ? AddCombo : Minus1} alt=""
                                                                onClick={() => handleAddOrDeleteVariants(index)} />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* .....................................mobileView............................ */}

            <div className='w-full h-full flex flex-col sm:!hidden overflow-hidden'>
                <div className='w-full h-max sticky top-0'>
                    <NavBarMobile title={'Add Addon'} />
                </div>
                <div className={`relative w-full h-full bg-[#fff] overflow-hidden ${sideNavState ? '' : ''}`} onClick={() => sideNavStateFunc(true)}>
                    <div className={`h-full w-max absolute left-0 bg-[#f5f5f5] transition-transform duration-5000 z-[9999] ${sideNavState ? "translate-x-0 ease-out shadow-[5px_5px_100px_rgba(0,0,0,0.4)]" : "-translate-x-full ease-in duration-5000"
                        }`}>
                        <SideNavMob focus={'Order & Billing'} />
                    </div>
                    <div className={`h-full w-max absolute right-0 bg-[#f5f5f5] transition-transform duration-5000 z-[9999] ${rightNavState ? "-translate-x-0 ease-out shadow-[5px_5px_100px_rgba(0,0,0,0.4)]" : "translate-x-full ease-in duration-5000"
                        }`}>
                        <RightNavMob />
                    </div>
                    <div className='w-full h-full flex flex-col font-nunito p-3 gap-3 overflow-hidden'>
                        <span className='underline'>Department Details</span>
                        <div className='w-full flex gap-3 z-[8888]'>
                            <div className='w-full flex flex-col gap-1'>
                                <span>Item Name</span>
                                {/* <input type="text" placeholder=''/> */}
                                <div className='w-full'>
                                    <Select
                                        styles={customStyles}
                                        placeholder='Select...'
                                        value={selectedOption}
                                        options={options}
                                        onChange={(selectedOption) => handleChange(selectedOption)}
                                    // components={{ 
                                    // 	Option: CustomOption,
                                    // 	SingleValue: CustomSingleValue, 
                                    // 	Placeholder: CustomPlaceholder
                                    // }}
                                    // isDisabled={true}
                                    />
                                </div>
                            </div>
                            {/* <div className='w-1/2 flex flex-col gap-1'>
                            <span>Item Code</span>
                            <input className={`h-[2.5rem] p-2 ${itemCode ? 'bg-slate-100' : ''}`} 
                            type="text" 
                            placeholder='' 
                            disabled={itemCode}
                            value={itemCode[0] && itemCode[0].itemCode}/>
                        </div> */}
                        </div>
                        {
                            selectedOption && (
                                <div className='relative flex flex-col w-full h-full text-center font-nunito text-[1rem] rounded-[.313rem] overflow-auto noScroll'>
                                    <div className='sticky top-0 w-full min-h-max flex font-[600] rounded-tl-[.313rem] bg-[#E5E5E5] text-nowrap z-[7777]'>
                                        <div className='min-w-[9rem] max-w-[9rem] p-3 bg-[#E5E5E5] text-left'>Item Name</div>
                                        <div className='min-w-[6rem] max-w-[6rem] p-3 bg-[#E5E5E5]'>Price</div>
                                        <div className='min-w-[5rem] max-w-[5rem] p-3 bg-[#E5E5E5]'></div>
                                        <div className='sticky right-0 min-w-[5rem] max-w-[5rem] p-3 rounded-tr-[.313rem] bg-[#E5E5E5] z-[7777]'>Action</div>
                                    </div>
                                    <div className='flex flex-col w-full z-[6666] text-wrap'>
                                        {addonCombos.map((addon, index) => (
                                            <div key={index} className='flex w-full h-[5rem]'>
                                                <div className='min-w-[9rem] max-w-[9rem] p-3 flex justify-center items-center relative'>
                                                    <input className={`w-full borderBottem pr-3 ${addonErrors[index]?.itemName ? 'AddonFieldError' : ''}`} type="text"
                                                        value={addon.itemName}
                                                        onBlur={() => handleOnBlurItemName(index)}
                                                        onChange={(e) => handleOnChangeValue(e, index, 'itemName')} />
                                                    {addon.itemName && (
                                                        <img className='absolute right-3 w-[1rem] cursor-pointer' src={domain} alt="" onClick={(e) => handleGenerateWebImg(e, index, addon.itemName, 'itemImage')} />
                                                    )}
                                                </div>
                                                <div className='min-w-[6rem] max-w-[6rem] p-3 flex justify-center items-center'>
                                                    <input className={`w-full borderBottem ${addonErrors[index]?.itemPrice ? 'AddonFieldError' : ''}`} type="number"
                                                        value={addon.itemPrice}
                                                        onBlur={() => handleOnBlurItemName(index)}
                                                        onChange={(e) => handleOnChangeValue(e, index, 'itemPrice')} />
                                                </div>
                                                <div className='min-w-[5rem] max-w-[5rem] p-3 flex justify-center items-center'>
                                                    <div className='w-max h-full flex justify-center p-1 items-center cursor-pointer rounded-[.313rem]' onClick={() => handleDivClick(index)}>
                                                        <input
                                                            type="file"
                                                            ref={fileInputRef.current[index]}
                                                            style={{ display: 'none' }}
                                                            onChange={(e) => handleImageChange(e, index, 'itemImage')}
                                                        />
                                                        {(loading || searchingWeb[index]) ? (
                                                            loading ? <div className='loading-indicator'>Uploading...</div> :
                                                                searchingWeb[index] === 1 ? <Lottie animationData={searchingLotties} loop={true} /> : null
                                                        ) : preview[index] ? (
                                                            <div className='w-full h-full relative'>
                                                                <img className='w-full h-full rounded-[.313rem]' src={preview[index]} alt="Uploaded" />
                                                            </div>
                                                        ) : (
                                                            <div className='flex flex-col justify-center items-center gap-2 text-[.75rem]'>
                                                                <img className={`w-[2rem]`} src={UploadImg} alt="Upload Image" />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className='sticky right-0 bg-[#fff] min-w-[5rem] miax-w-[5rem] p-3 flex justify-center items-center gap-2 z-[6666]'>
                                                    <img className='w-[1.25rem] cursor-pointer' src={addon.isAdding ? AddCombo : Minus1} alt=""
                                                        onClick={() => handleAddOrDeleteVariants(index)} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className='flex w-full h-max gap-3 px-3 pb-3'>
                    <button className='w-1/2 loginBorder bg-[#fff] text-[#0008B4] rounded-[.313rem] py-2' onClick={handleCancel}>Cancel</button>
                    <button className='w-1/2 loginBorder bg-[#0008B4] text-[#fff] rounded-[.313rem] py-2' onClick={handleSaveAddon}>Save</button>
                </div>
            </div>
        </div>
    )
}

export default AddonReg
